import {actions} from "./actionTypes";
import {keyTokenLogin, userLogin, userNameLogin} from "../util/constants";
import {store} from "../App";
import {generalConfig} from "../util/config";

const dispatchDataRedux = (data) =>{
    store.dispatch(data);
};

export const getSessionState = () =>{
    return store.getState().sessionState;
};

export const getAlertState = () =>{
    return store.getState().alertState;
};

export const showLoading = (visible)=>{
    dispatchDataRedux({
        type: actions.SHOW_LOADING,
        visible: visible
    });
};

export const loadingOn = () => {
    showLoading(true);
};

export const loadingOff = () => {
    showLoading(false);
};

export const setUserLoggedOnRedux = (user, userName,token) =>{
    dispatchDataRedux({
        type: actions.SET_USER,
        userLogged: user,
        userNameLogged: userName,
        tokenUserLogged: token,
    });
};

export const getHeaderDefault = () =>{
    return {
        "Content-Type": "application/json; charset=utf-8",
        "authorization": getSessionState().tokenUserLogged,
        "user": getSessionState().userLogged
    };
};

export const isLogged = () =>{
    if(getSessionState().userLogged == "" || getSessionState().userLogged == undefined)
        return false;

    return  true;
}

export const setAlertOnRedux = (visible, icon, text,type, time = generalConfig.timeAlertDefault) =>{
    let alert = { visible: visible, icon: icon, text: text, alertType: type};
    window.scrollTo(0, 0);
    dispatchDataRedux ({
        type: actions.SET_ALERT,
        alert: alert
    });
    if(visible){
        setTimeout(()=>{
            setAlertOnRedux(false,"","", "")
        }, time);
    }
};

export const setAlertOnReduxWithTime = (visible, icon, text,type,time) =>{
    setAlertOnRedux(visible, icon, text,type);
    setTimeout(()=>{
        clearAlertOnRedux();
        }, time);

};

export const clearAlertOnRedux = ()=>{
    dispatchDataRedux ({
        type: actions.SET_ALERT,
        alert: {visible: false, icon: "", text: "", alertType: ""}
    });
};

export const removeTokenUserStorage = () => {
    removeStorage(keyTokenLogin);
    removeStorage(userLogin);
    removeStorage(userNameLogin);
    setUserLoggedOnRedux(null,null,null);
};

export const validRemoveTokenUserStorage = (status) =>{
    if(status === 401 ||  status === 403) {
        return true;
    }
    return false;
};

export const setTokenUserStorage = (token,user,userName) =>{
    setStorage(keyTokenLogin, token);
    setStorage(userLogin, user);
    setStorage(userNameLogin,userName);
};

export const setStorage = (key,item) =>{
    return localStorage.setItem(key,item);
};

export const getStorage = (item) =>{
    return localStorage.getItem(item);
};

export const removeStorage = (item) =>{
    return localStorage.removeItem(item);
};


// WEBPACK FOOTER //
// ./src/actions/index.js